import React from "react";
import Svg, { Path, G } from "react-native-svg";
import { TouchableOpacity } from "react-native";

import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";

export default function MenuIcon(props) {
  const color = AppTheme.iconBlack;

  return (
    <TouchableOpacity {...props} style={[appStyles.iconContainer, props.style]}>
      <Svg
        width="20"
        height="20"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.0625 13.5601H5.4375C4.875 13.5601 4.5 13.9381 4.5 14.5051V16.3951C4.5 16.9621 4.875 17.3401 5.4375 17.3401H26.0625C26.625 17.3401 27 16.9621 27 16.3951V14.5051C27 13.9381 26.625 13.5601 26.0625 13.5601Z"
          fill={color}
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.0625 6H5.4375C4.875 6 4.5 6.378 4.5 6.945V8.835C4.5 9.402 4.875 9.78 5.4375 9.78H26.0625C26.625 9.78 27 9.402 27 8.835V6.945C27 6.378 26.625 6 26.0625 6Z"
          fill={color}
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.0625 21.12H5.4375C4.875 21.12 4.5 21.498 4.5 22.065V23.955C4.5 24.522 4.875 24.9 5.4375 24.9H26.0625C26.625 24.9 27 24.522 27 23.955V22.065C27 21.498 26.625 21.12 26.0625 21.12Z"
          fill={color}
        />
      </Svg>
    </TouchableOpacity>
  );
}
